//PassFailAnalysisReports
<template>
    <div>
        <v-snackbar v-model="snackbar" top :color="color" :timeout="6000" rounded elevation="2">
            <span v-if="snackbar_msg">{{ snackbar_msg }}</span>
            <v-btn dark text small @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-card class="pa-4 rounded-xl elevation-2">
            <v-tabs
                v-model="tabs"
                background-color="brand"
                dark
                grow
                slider-color="yellow"
                class="rounded-xl no-display"
            >
                <v-tab>
                    <v-icon left>mdi mdi-file-document-check-outline</v-icon>
                    Class Wise Pass / Fail Analysis
                </v-tab>
                <v-tab>
                    <v-icon left>mdi mdi-file-document-check</v-icon>
                    Subject Wise Pass / Fail Analysis
                </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tabs">
                <v-tab-item>
                    <v-card flat class="pt-1">
                        <class-wise-analysis></class-wise-analysis>
                    </v-card>
                </v-tab-item>
                <v-tab-item>
                    <v-card flat>
                        <subject-wise-analysis></subject-wise-analysis>
                    </v-card>
                </v-tab-item>
            </v-tabs-items>
        </v-card>
    </div>
</template>

<script>
    import axios from "axios";
    import "@/assets/css/color.css";
    import SubjectWiseAnalysis from "./SubjectWisePassFailReport.vue";
    import ClassWiseAnalysis from "./ClassWisePassFailReport.vue";

    export default {
        components: {
            SubjectWiseAnalysis,
            ClassWiseAnalysis,
        },
        data() {
            return {
                snackbar_msg: "",
                color: "",
                snackbar: false,
                tabs: 0,
            };
        },

        methods: {
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },

        mounted() {},
    };
</script>

<style scoped>
    .v-tabs {
        border-radius: 12px;
    }

    .v-tab {
        font-weight: bold;
        letter-spacing: 0.5px;
    }
    @media print {
        .no-display,
        .v-input__control,
        input[type="button"],
        input[type="submit"],
        input[type="reset"],
        #v-card {
            display: none !important;
        }
    }
</style>
